
        var normalize = require("../../../node_modules/san-loader/lib/runtime/normalize.js");
        require('/Users/duanhong/Source/Lean/LeanPM/webapps/shared/src/components/Turn/Turn.san?lang=less&san=&type=style&index=0');
var injectStyles = [];

        var template = require('./Turn.html');
        
        var script = require('./Turn.ts').default;
        module.exports = require('./Turn.ts');
    
        module.exports.default = normalize(script, template, injectStyles);
        /* san-hmr component */
    